import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

const WhatsAppSVG = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
);

const InstagramSVG = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
);

const YouTubeSVG = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
);

const FacebookSVG = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
);

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useLang();
  return (
    <footer className="relative overflow-hidden border-t border-purple/15" data-testid="footer">
      <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, #1a0710 0%, #0f0508 100%)' }} />

      <div className="container-custom relative z-10 py-16">
        {/* Devotional Shloka */}
        <div className="text-center mb-12">
          <p className="text-4xl text-gold/20 om-glow font-heading mb-3">ॐ</p>
          <p className="text-gold/40 font-heading italic text-sm">
            {t('footer.shloka')}
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/brand/va-icon-transparent-512.png"
                alt="ViratAstro VA Monogram"
                width="48" height="48"
                className="w-12 h-12 drop-shadow-[0_0_10px_rgba(212,175,55,0.5)]"
                loading="lazy"
                decoding="async"
                data-testid="footer-logo-img"
              />
              <div>
                <h3 className="font-heading text-xl text-text-main">ViratAstro</h3>
                <p className="text-[10px] text-gold/50 tracking-[0.25em] uppercase">Astrology & Vastu</p>
              </div>
            </div>
            <p className="text-text-muted leading-relaxed max-w-sm">
              <strong className="text-gold">Vivek Mudgal</strong> (Astrologer, Vastu Expert & Cosmic Healer) - 33+ years of divine Vedic wisdom serving globally.
            </p>
            <p className="text-text-muted/50 text-sm mt-2 font-heading italic">
              विवेक मुद्गल - 33+ वर्षों का दिव्य अनुभव
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg text-text-main mb-4">{t('footer.quickLinks')}</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2.5">
              {[
                { link: '/kundli', name: 'Kundli' },
                { link: '/gun-milan', name: 'Gun Milan' },
                { link: '/daily-rashifal', name: 'Rashifal' },
                { link: '/daily-panchang', name: 'Panchang' },
                { link: '/daily-tarot', name: 'Tarot' },
                { link: '/numerology', name: 'Numerology' },
                { link: '/upay', name: 'नवग्रह उपाय' },
                { link: '/poocho-guruji', name: 'पूछो Guruji' },
                { link: '/experts', name: 'Experts Directory' },
                { link: '/experts/vivek-virat-mudgal', name: 'Acharya Vivek जी' },
                { link: '/experts/priya-khurana', name: 'Tarot · Priya (Dubai)' },
                { link: '/faq', name: 'FAQs' },
                { link: '/blog', name: 'Blog' },
                { link: '/about', name: 'About' },
                { link: '/#vastu', name: 'Vastu' },
                { link: '/privacy-policy', name: 'Privacy Policy' },
                { link: '/terms', name: 'Terms' },
                { link: '/refund-policy', name: 'Refund Policy' },
              ].map((item, i) => (
                <Link key={i} to={item.link} className="block text-text-muted hover:text-gold transition-colors text-sm">
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg text-text-main mb-4">{t('footer.contact')}</h4>
            <div className="space-y-3">
              <a href="https://wa.me/919311369729" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 text-text-muted hover:text-green-400 text-sm transition-colors">
                <WhatsAppSVG /> +91 93113 69729
              </a>
              <div className="flex items-start gap-2 text-text-muted text-sm">
                <MapPin className="w-4 h-4 text-gold/60 mt-0.5 flex-shrink-0" />
                <span>PB-77 GF Parklands Pride, Sector 77, Faridabad, Haryana</span>
              </div>
              {/* Social Media */}
              <div className="flex items-center gap-3 mt-4">
                <a href="https://www.instagram.com/astrovivekmudgal" target="_blank" rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-gradient-to-br from-pink-500/20 to-purple-500/20 flex items-center justify-center text-pink-400 hover:text-pink-300 hover:scale-110 transition-all" data-testid="social-instagram">
                  <InstagramSVG />
                </a>
                <a href="https://youtube.com/@astrovivekmudgal" target="_blank" rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-red-500/15 flex items-center justify-center text-red-400 hover:text-red-300 hover:scale-110 transition-all" data-testid="social-youtube">
                  <YouTubeSVG />
                </a>
                <a href="https://www.facebook.com/share/1KEWbgnpEE/" target="_blank" rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-blue-500/15 flex items-center justify-center text-blue-400 hover:text-blue-300 hover:scale-110 transition-all" data-testid="social-facebook">
                  <FacebookSVG />
                </a>
                <a href="https://g.page/r/CbtzPR3gc6gNEBM/review" target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 px-2.5 h-9 rounded-full bg-blue-500 hover:bg-blue-600 text-white text-xs font-semibold transition-all hover:scale-105" data-testid="social-google-review"
                  aria-label="Leave a Google Review for Vivek Mudgal Astrologer">
                  <svg width="14" height="14" viewBox="0 0 48 48" fill="currentColor"><path d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"/></svg>
                  Review
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="divine-divider mt-12 mb-6" />
        <p className="text-text-muted/30 text-sm text-center">
          © {currentYear} ViratAstro | Vivek Mudgal. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
